import { EqMagModal } from './EqMagModal';

export const EqMbMagModal = EqMagModal({
  title: 'Mb Magnitude',
  desc: 'The Mb magnitude is the compressional body wave (P-wave) magnitude.',
});
